import React, { useState } from 'react';
import Select from 'react-select';
// import { handleOnFocusById } from '../../common/utils/CommonUtils';
import './CustomSelect.css'
export default function CustomSelect(props) {

    const [data, setData] = useState(null);

    const customStyles = {

        container: (base) => ({
            ...base,
            height: '100%',
            minWidth: '7.39vw'
        }),

        control: (base, state) => ({
            ...base,
            border: state.isFocused ? '0.052vw solid #6D1DF0' : 0,
            boxShadow: 'none',
            height: '100%',
            minHeight: props.controlHeight || '2.08vw',
            borderStyle: 'none',
            borderRadius: props.borderradiusValueContainer || '0.42vw',
            backgroundColor: props.backgroundColor || '#141414',
            '&:hover': {
                border: '0.052vw solid #6D1DF0',
            }
        }),
        
        placeholder: (base) => ({
            ...base,
            fontSize: props?.placeholderFontSize || '0.83vw',
            fontWeight: props?.placeholderFontWeight || 400,
        }),
        menu: (base) => ({
            ...base,
            marginTop: '0.26vw',
            marginBottom: '0px',
            backgroundColor: '#333333',
            "&:hover": {
                borderColor: "red",
                borderRadius: '0.26vw'
            }
        }),
        valueContainer: (base) => ({
            ...base,
            padding: props?.paddingValueContainer || '0.1vw 0.83vw',
            
            
           
            
            
        }),
        option: (base, state) => ({
            ...base,
            padding: props.optionPadding || '0.88vw',
            fontSize: props.optionFontSize || '2 rem',
            "&:hover": {
                backgroundColor: "#8d1df9"
            },
            backgroundColor: state.isSelected ? '#6d1df0' : '',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: props.singleValFontSize || '2 rem',
            color: '#FFFFFF'
        }),
        input: (base) => ({
            ...base,
            fontWeight: '400',
            fontSize: '0.83vw',
            lineHeight: '0.83vw',
            color: '#FFFFFF;'
        })
    }

    const handleChange = (item) => {
        setData(item);

        props.handleChange(item);
    }

    return (
        <Select
            closeMenuOnSelect={props.closeMenuOnSelect}
            id={props.id}
            className={props.className || 'custom-select'}
            value={props.hasOwnProperty('value') ? props.value : data}
            onChange={handleChange}
            isClearable={props.hasOwnProperty('isClearable') ? props.isClearable : true}
            options={props.options || []}
            getOptionValue={(option) => option[props['label']] || option['label'] || option.name}
            getOptionLabel={(option) => option[props['label']] || option['label'] || option.name}
            placeholder={props.placeholder}
            styles={customStyles}
            isMulti={props.isMulti || false}
            isDisabled={props.isDisabled ? true : false}
            // menuIsOpen={true}
            components={{
                //DropdownIndicator:() => null,
                IndicatorSeparator: () => null
            }}
            onFocus={() => {
                // handleOnFocusById(`${props.id || props.placeholder}`)
            }}
            isSearchable={props.isSearchable}
        />
    )
}


// behavior Optional
// Defines the transition animation. One of auto or smooth. Defaults to auto.

// block Optional
// Defines vertical alignment. One of start, center, end, or nearest. Defaults to start.

// inline Optional
// Defines horizontal alignment. One of start, center, end, or nearest. Defaults to nearest.